import React, { useEffect, useRef, useState } from 'react';
import { EqualHeightElement } from 'react-equal-height';
import { useDispatch, useSelector } from 'react-redux';

// Prime-React Components
import { Menu } from 'primereact/menu';
import { Chart } from 'primereact/chart';
import { Button } from 'primereact/button';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-plugin-datalabels';

// Components
import { CustomeTooltip } from './ActionButtons';

// Constants
import { barOptions } from '../constants/chartConstants';
import { wordCapitalize } from '../utils/common';

// Images
import filterIc from '@assets/images/filter-ic.svg';
import filterIcDark from '@assets/images/filter-ic-dark.svg';
import { getScheduleInterviewCountByHR } from '../redux/actions/hr';
import { getDateWithDay } from '../utils/date';
import moment from 'moment';

const AvailableInterviewersBarChart = () => {
  const menu = useRef(null);
  const dispatch = useDispatch();
  const [hrData, setHrData] = useState([]);
  const [filter, setFilter] = useState('day');
  const scheduleInterviewCount = useSelector((state) => state.hrs.scheduleInterviewCount);

  function modifiedHrData(data) {
    const scheduleInterviews = data || [];
    let labels = [];
    let interviewsData = [];

    scheduleInterviews.forEach((hr) => {
      labels.push(
        `${hr?.FirstName ? wordCapitalize(hr?.FirstName) : ''} ${
          hr?.LastName ? wordCapitalize(hr?.LastName) : ''
        }`
      ),
        interviewsData.push(hr?.RoundOfHR?.length || 0);
    });
    return { labels, interviewsData };
  }

  useEffect(() => {
    setHrData(modifiedHrData(scheduleInterviewCount));
  }, [scheduleInterviewCount]);

  const todaysInterviewerChartData = {
    labels: hrData?.labels || [],
    datasets: [
      {
        data: hrData?.interviewsData || [],
        borderWidth: 0,
        borderRadius: 50,
        barThickness: 20,
        backgroundColor: [
          '#7986CB',
          '#9575CD',
          '#4FC3F7',
          '#4DB6AC',
          '#AED581',
          '#90A4AE',
          '#BA68C8'
        ],
        hoverBackgroundColor: [
          '#7986CB',
          '#9575CD',
          '#4FC3F7',
          '#4DB6AC',
          '#AED581',
          '#90A4AE',
          '#BA68C8'
        ],
        datalabels: {
          color: '#FFF'
        }
      }
    ]
  };

  const technologyFilter = [
    {
      label: 'Today',
      value: 1,
      command: () => setFilter('day'),
      className: filter === 'day' ? 'highlighted-item' : ''
    },
    {
      label: 'Weekly',
      value: 1,
      command: () => setFilter('week'),
      className: filter === 'week' ? 'highlighted-item' : ''
    },
    {
      label: 'Monthly',
      value: 2,
      command: () => setFilter('month'),
      className: filter === 'month' ? 'highlighted-item' : ''
    }
  ];

  useEffect(() => {
    var startOfWeek = getDateWithDay(moment().startOf(filter).toDate());
    var endOfWeek = getDateWithDay(moment().endOf(filter).toDate());
    if (filter) {
      dispatch(getScheduleInterviewCountByHR(startOfWeek, endOfWeek));
    }
  }, [dispatch, filter]);

  return (
    <div className="white-box-item full-width">
      <div className="white-box">
        <div className="card-title-block">
          <EqualHeightElement name="title">
            <div>
              <span className="card-title">Schedule Interviews count by HRs</span>
              <i
                className="custom-target-icon pi pi-info-circle pl-1"
                data-tip="Number of Interviews count schedule by HRs"
                style={{ cursor: 'pointer' }}
              />
            </div>
          </EqualHeightElement>
          <div className="filter-block">
            <Menu
              model={technologyFilter}
              popup
              ref={menu}
              id="popup_menu"
              appendTo="self"
              className="popup_menu action-popup chartFilterMenu"
            />
            <CustomeTooltip />
            <Button
              data-tip="Filter By"
              type="button"
              onClick={(event) => menu.current.toggle(event)}
              aria-controls="popup_menu"
              aria-haspopup
              className="p-button-rounded p-button-text border-none primary-icon-btn filter-btn">
              <i>
                <img src={filterIc} className="default-img" alt="filter" />
                <img src={filterIcDark} className="dark-mode-img" alt="filter" />
              </i>
            </Button>
          </div>
        </div>
        <div className="chart-figure-wrapper">
          <Chart
            type="bar"
            data={todaysInterviewerChartData}
            options={barOptions}
            plugins={[ChartDataLabels]}
          />
        </div>
      </div>
    </div>
  );
};

export default AvailableInterviewersBarChart;
